import AxiosConfig from "./AxiosConfig";
import DateService from "./DateService";

const saveFile = async (file, typeJustificatif) => {
    if (process.env.REACT_APP_MODE === 'maquette') {

    } else {
        if (typeJustificatif) {
            const formData = new FormData();
            formData.append('file', file);

            try {
                const response = await AxiosConfig.post(`/justificatif/create/${typeJustificatif}`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                return { success: true, message: "Fichier enregistré avec succès", response: response };

            } catch (error) {
                console.error('Erreur lors de l\'enregistrement du fichier :', error);
                throw error; // Assurez-vous que cette exception est bien gérée à un niveau supérieur
            }
        } else {
            return {success: false, message: "Type de justificatif non trouvé"};
        }
    }

    return {success: true, message: "Fichier enregistré avec succès"};
};

const renameFileJustificatif = (originFile, targetId, idForFileName) => {
    if (!originFile) return;

    let fileName = "";

    switch (targetId) {
        case "ci_file":
            fileName = "ci_" + idForFileName + "." + originFile.name.split('.').pop();
            break;
        case "rib_file":
            fileName = "rib_" + idForFileName + "." + originFile.name.split('.').pop();
            break;
        case "cert_file":
            fileName = "cert_" + idForFileName + "." + originFile.name.split('.').pop();
            break;
        default:
            fileName = "unknow_" + idForFileName + "." + originFile.name.split('.').pop();
            break;
    }
    return true;

    return new File([originFile], fileName, { type: originFile.type });
};

const getJustificatifsFiles = async () => {
    try {
        const response = await AxiosConfig.get(`/justificatifs`);
        return response.data.justificatifs;
    } catch (error) {
        console.error('Erreur lors de la récupération des justificatifs :', error);
        throw error;
    }
}

const getJustificatifsTypes = async () => {
    try {
        const response = await AxiosConfig.get(`/justificatif/types`);
        return response.data.justificatifTypes;
    } catch (error) {
        console.error('Erreur lors de la récupération des types de justificatifs :', error);
        throw error;
    }
}

const getJustificatifsTypesObligatoires = async () => {
    try {
        const response = await AxiosConfig.get(`/justificatif/types/obligatoires`);
        return response.data.justificatifTypes;
    } catch (error) {
        console.error('Erreur lors de la récupération des types de justificatifs :', error);
        throw error;
    }
}

const deleteJustificatif = async (justificatifId) => {
    try {
        const response = await AxiosConfig.post(`/justificatif/delete/${justificatifId}`);
        return { success: true, message: "Justificatif supprimé avec succès" };
    } catch (error) {
        console.error("Erreur lors de la suppression du justificatif:", error);
        return { success: false, message: "Justificatif non supprimé" };
    }
}

const handleSubmitLogoEntreprise = async (values, { setSubmitting, resetForm, setErrors }) => {
    if (values.file) {
        const formData = new FormData();
        formData.append("file", values.file);

        try {
            const response = await AxiosConfig.post("/entreprise/logo", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            resetForm();
            return response.data;
        } catch (error) {
            console.error("Erreur lors de l'upload du fichier", error);
        }
    } else {
        setErrors({ file: "Un fichier est requis" });
    }

    setSubmitting(false);
};

const generateCsv = () => {
    const headers = [
        'nom',
        'prenom',
        'email',
        'civilite',
        'date_naissance',
        'tel_mobile',
    ];
    let csvContent = headers.join(';') + '\n';
    csvContent += 'David;Dupont;david.dupont@example.com;monsieur;01/01/1980;+33601020304\n';
    csvContent += 'Marie;DURAND;marie.durand at example.com;madame;1985-02-02;0605060708\n';
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = 'import_utilisateurs.csv';
    link.style.visibility = 'hidden';

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
};

const handleSubmitCsvUsers = async (values, entrepriseId, overwrite = false) => {
    if (!entrepriseId) {
        return {
            "success": false,
            "msg": 'Veuillez sélectionner une entreprise.',
        };
    }
    const file = values.file;
    if (!file) {
        return {
            "success": false,
            "msg": 'Veuillez sélectionner un fichier CSV.',
        };
    }

    const formData = new FormData();
    formData.append('file', file);
    formData.append('overwrite', overwrite);

    try {
        const response = await AxiosConfig.post(`/admin/utilisateurs/import_csv/${entrepriseId}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });

        return {
            "success": response.data.success,
            "msg": response.data.message,
            'nbUtilisateursImportes': response.data.nbUtilisateursImportes,
        };
    } catch (error) {
        console.error('error', error);
        if (error.code === "ERR_NETWORK") {
            return {
                "success": false,
                "msg": "Erreur lors de l'envoi, essayez de recharger la page et re-sélectionner le fichier.",
            };
        }
        return {
            "success": false,
            "msg": "Erreur lors de l'envoi",
        };
    }
};

const formatType = (justType) => ({
    id: justType?.justId ?? "",
    label: justType?.justLabel ?? "",
    obligatoire: justType?.justObligatoire ?? "",
    role: justType?.justRole ?? "",
});

const formatUser = (user) => ({
    id: user?.id ?? "",
    nom: user?.nom ?? "",
});

const reassignJustificatifCommonProps = (just) => ({
    created_at: just?.createdAt ?? "",
    created_by: formatUser(just?.createdBy),
    updated_at: just?.updatedAt ?? "",
    updated_by: formatUser(just?.updatedBy),
    actif: just?.actif ?? "",
    file: just?.file ?? "",
    uid: just?.uid ?? "",
});

const reassignmentJustificatif = (j) => {
    if (j && j.id) {
        return j;
    } else if (j.justificatifId) {
        return {
            id: j.justificatifId,
            type: formatType(j.justificatifType),
            ...reassignJustificatifCommonProps({
                createdAt: j.justificatifCreatedAt,
                createdBy: j.justificatifCreatedBy,
                updatedAt: j.justificatifUpdatedAt,
                updatedBy: j.justificatifUpdatedBy,
                actif: j.justificatifActif,
                file: j.justificatifFile,
                uid: j.justificatifUid,
            }),
        };
    } else if (j.jusId) {
        return {
            id: j.jusId,
            type: formatType(j.jusType),
            ...reassignJustificatifCommonProps({
                createdAt: j.jusCreatedAt,
                createdBy: j.jusCreatedBy,
                updatedAt: j.jusUpdatedAt,
                updatedBy: j.jusUpdatedBy,
                actif: j.jusActif,
                file: j.jusFile,
                uid: j.jusUid,
            }),
        };
    }
    return j;
};

const flattenObject = (obj, parentPrefix = '') => {
    let flattened = {};

    for (const key in obj) {
        const propName = parentPrefix ? `${parentPrefix}__${key}` : key;

        if (typeof obj[key] === 'object' && obj[key] !== null && !Array.isArray(obj[key])) {
            Object.assign(flattened, flattenObject(obj[key], propName));
        } else {
            flattened[propName] = obj[key] === null ? '' : obj[key];
        }
    }

    return flattened;
};

const exportToCsv = (filename, rows, headers = null, separator = ";") => {
    const csvContent = [];
    if (rows.length > 0) {
        let headerKeys = null;
        let headerNames = null;
        if (headers) {
            headerNames = headers.map(header => header.Header);
            headerKeys = headers.map(header => header.accessor.replace('.', '__'));
            csvContent.push(headerNames.join(separator));
        } else {
            headerKeys = Object.keys(flattenObject(rows[0]));
            csvContent.push(headerKeys.join(separator));
        }

        rows.forEach(row => {
            const flattenedRow = flattenObject(row);
            const values = headerKeys.map(header => {
                let cellValue = flattenedRow[header] !== null ? flattenedRow[header] : '';
                if (DateService.isValidISODate(cellValue) && DateService.isValidDate(cellValue)) {
                    cellValue = DateService.formatDateWithSeconds(cellValue);
                }
                return `"${String(cellValue).replace(/"/g, '""')}"`;
            });
            csvContent.push(values.join(separator));
        });
    }

    const blob = new Blob([csvContent.join('\n')], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

// Utilise cette méthode pour télécharger un justificatif
const downloadFile = async (fichier) => {
    if (fichier && fichier.file) {
        try {
            const response = await AxiosConfig.get(`/justificatifget/${fichier.id}`, { responseType: 'arraybuffer' });
            const url = window.URL.createObjectURL(new Blob([response.data]));

            const link = document.createElement('a');
            link.href = url;
            let type = response.headers['content-type'];
            let extension = type.split("/")[1] || "png";
            let fileName = fichier.type.label + "." + extension;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);

            return { success: true, message: "Fichier téléchargé avec succès" };
        } catch (error) {
            console.error("Erreur lors de la récupération du fichier", error);
            return { success: false, message: "Erreur lors de la récupération du fichier" };
        }
    }
};

export {
    saveFile,
    renameFileJustificatif,
    getJustificatifsFiles,
    getJustificatifsTypes,
    getJustificatifsTypesObligatoires,
    deleteJustificatif,
    handleSubmitLogoEntreprise,
    generateCsv,
    handleSubmitCsvUsers,
    reassignmentJustificatif,
    exportToCsv,
    flattenObject,
    downloadFile,
};
